import { mobile } from "../../../mediaQueries"

const styles = theme => ({
    root: {
        flexBasis: '40%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        opacity: 0,
        [theme.breakpoints.up(theme.breakpoints.values.xs + 1920)]: {
            flexBasis: 'auto',
            width: 'auto'
        },
        zIndex: 2,
        transition: 'opacity 2.5s cubic-bezier(.4,.28,0,1.03)',
        alignItems: 'flex-start',
        flexDirection: 'column',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 850)]: {
            textAlign: 'center',
            order: 0
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            flexBasis: 'auto',
            height: 'fit-content',
            width: '100%',
            paddingLeft: '0'
        }
    },
    h1: {
        fontFamily: 'Playfair Display',
        color: '#575452',
        fontWeight: '500',
        fontSize: '3rem',
        letterSpacing: '0.02em',
        lineHeight: '67.2px',
        margin: '0 0 30px 0',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 850)]: {
            width: '100%'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            fontSize: props => `${props.smaller ? 26 : 32}px`,
            lineHeight: 'initial',
            textAlign: 'center',
            marginBottom: '12px'
        }
    },
    h3: {
        fontFamily: 'Aktiv Grotesk',
        fontWeight: '400',
        fontSize: '1rem',
        letterSpacing: '0.01em',
        color: '#575452',
        lineHeight: '25.6px',
        maxWidth: '63ch',
        margin: '0',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 850)]: {
            margin: 'auto'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            textAlign: 'center',
            fontSize: '14px',
            maxWidth: '100%',
            letterSpacing: '0.02em'
        }
    }
})

export default styles